import React from "react";
import CustomButton from "../../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const variants = {
  initial: {
    x: -50,
    Opacity: 0,
  },
  animate: {
    x: 0,
    Opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      staggerChildren: 0.1,
    },
  },
};

const OurMission = () => {
  const navigate = useNavigate();
  const handleNavigation = () => {
    window.scroll(0, 0);
    navigate("/aboutUs");
  };
  return (
    <div className=" w-full h-full lg:h-3/5 flex flex-col-reverse lg:flex-row bg-backgroundColor">
      <div className="w-full lg:w-1/2 p-6 md:p-4 lg:p-5 flex-[0.5] bg-primaryColor flex flex-col items-center justify-center md:gap-4">
        <motion.div variants={variants}>
          <h2 className=" font-CrimsonText font-bold text-2xl md:text-4xl text-white">
            Our Mission
          </h2>
        </motion.div>
        <motion.p
          initial={{ scale: 0.5, x: 100 }}
          whileInView={{ opacity: 1, scale: 1, x: 0 }}
          transition={{ duration: 1.5 }}
          viewport={{ once: true }}
          className="  font-CrimsonText font-normal text-base text-justify lg:text-lg text-white "
        >
          Our mission is to deliver innovative engineering solutions for the
          energy and data center sectors, ensuring operational excellence,
          sustainability, and reliability while building lasting partnerships
          and exceeding client expectations.
        </motion.p>
        <motion.div
          className="mt-4"
          initial={{ opacity: 0, x: -200 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ type: "spring", stiffness: 100, damping: 20 }}
        >
          <CustomButton
            title="Discover More"
            className=" w-[120px] h-[40px] md:w-[154px] md:h-[51px] text-base hover:bg-white hover:text-textColor border-2 border-white"
            onClick={handleNavigation}
          />
        </motion.div>
      </div>
      <div className="w-full h-72 lg:h-auto lg:w-1/2 flex-[0.5]">
        <img
          src={require("../../../assets/whoWeAre4.png")}
          // src={require("../../../assets/projectImg2.png")}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
};

export default OurMission;
